import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import { MenuItem, Dropdown } from 'react-bootstrap';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';
import yesIcon from '../host/assets/yes-icon.png';
import noIcon from '../host/assets/no-icon.png';

const moment = require('moment');

const individualUserExcelDownload = AdminUrls.ADMIN.INDIVIDUALUSEREXCEL;
const cpdIndividual_Url = AdminUrls.ADMIN.CPDINDIVIDUALREPORT;
const cpdAttachDownload_Url = AdminUrls.ADMIN.REPORTDOWNLOAD;
const cpdLocked_Url = AdminUrls.ADMIN.UPDATELOCKEDSTATUS;
const LoadHost_Url = AdminUrls.COMMON.LOADHOST;

class CompliantReport extends React.Component {
  constructor() {
    super();

    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.getCpdCompliantReport = this.getCpdCompliantReport.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
    this.cpdLockedHandler = this.cpdLockedHandler.bind(this);
    this.cpdUnLockedHandler = this.cpdUnLockedHandler.bind(this);
    this.editViewHandler = this.editViewHandler.bind(this);
    this.pageChange = this.pageChange.bind(this);

    this.state = {
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdId: '',
      cpdBool: '',
      cpdMemberNum: '',
      cpdCourseName: '',
      cpdUsername: '',
      cpdYear: '',
      cpdHostName: '',
      loadCpdIndividual: [],
      loadHost: [],
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      sort: {
        column: 'WorkflowStamp',
        direction: 'desc',
      },
      yearCpd: '',
    };
    this.controller = new AbortController();
  }

  downloadExcel(year) {
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(individualUserExcelDownload, {
      params: {
        reportId: this.state.cpdId,
        Year: year,
      },
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        name = 'individualuserReport.xlsx';
        var header = response.headers['content-disposition'];
        if (header) {
          name = header.split('=')[1].replace(/\"/gi, '');
        }
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var blob = new Blob([response.data], { type: fileType });
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          //link.setAttribute('download', 'individualuserreport.xlsx');
          link.setAttribute('download', name);
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.getCpdCompliantReport(pageNumber, this?.state?.yearCpd);
  }

  pageChange(pageQty) {
    this.setState(
      {
        per_page: pageQty,
      },
      () => {
        this.getCpdCompliantReport(
          this?.state?.activePage,
          this?.state?.yearCpd
        );
      }
    );
  }

  componentDidMount() {
    this.setState(
      {
        yearCpd: this.props.location?.state,
      },
      this.getLoadCpd()
    );
  }

  clearSearchFilters() {
    this.setState(
      {
        totalPages: 0,
        totalCount: 0,
        per_page: 10,
        activePage: 0,
        unauthorized: false,
        cpdCourseName: '',
        cpdMemberNum: '',
        cpdUsername: '',
        cpdHostName: '',
        cpdYear: '',
      },
      () => {
        this.getCpdCompliantReport(1, this?.state?.yearCpd);
      }
    );
  }

  getCpdCompliantReport(active, year, column, direction) {
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    this.setState({
      mainLoading: true,
    });
    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }
    reverse = reverse === 'asc' ? false : true;
    axios
      .get(cpdIndividual_Url, {
        params: {
          Year: year,
          page: active,
          pageSize: this.state.per_page,
          reverse: reverse,
          sortBy: sortBy,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdIndividual: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  searchData() {
    let userNames = this.state.cpdUsername;
    let CourseName = this.state.cpdCourseName;
    let year = this.state.cpdYear;
    let memberNumbers = this.state.cpdMemberNum;
    let host = this.state.cpdHostName;
    let pages = this.state.activePage;

    this.setState({
      mainLoading: true,
    });

    let obj = {
      Year: new Date().getFullYear(),
      reverse: true,
      sortBy: 'WorkflowStamp',
      page: pages,
      pageSize: this.state.per_page,
    };

    if (userNames) {
      obj.UserName = userNames;
    }

    if (CourseName) {
      obj.CourseName = CourseName;
    }
    if (year) {
      obj.Year = year;
    }
    if (memberNumbers) {
      obj.MemberNumber = memberNumbers;
    }
    if (host) {
      obj.HostId = host;
    }

    axios
      .get(cpdIndividual_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdIndividual: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  getLoadCpd() {
    this.setState({ mainLoading: true });

    axios
      .get(LoadHost_Url, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loadHost: data,
          mainLoading: false,
        });

        this.getCpdCompliantReport(1, this?.state?.yearCpd);
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handleDownloadFile(id) {
    let dup = [...this.state.loadCpdIndividual];
    let findData = dup.find((x) => x.CPDWorkflowId === id);
    axios
      .get(cpdAttachDownload_Url, {
        params: {
          name: findData?.AttachmentName,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        var blob = new Blob([response?.data]);

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, findData?.AttachmentName);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', findData?.AttachmentName);
          document.body.appendChild(link);
          link.click();
        }
      });
  }

  cpdLockedHandler(id) {
    this.setState({
      mainLoading: true,
    });

    axios
      .get(cpdLocked_Url, {
        params: {
          workflowId: id,
          isLocked: true,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          mainLoading: false,
        });

        this.getCpdCompliantReport(
          this.state.activePage,
          new Date().getFullYear()
        );
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  cpdUnLockedHandler(id) {
    this.setState({
      mainLoading: true,
    });

    axios
      .get(cpdLocked_Url, {
        params: {
          workflowId: id,
          isLocked: false,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          mainLoading: false,
        });

        this.getCpdCompliantReport(this.state.activePage, 2024);
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  editViewHandler(id, mode, item) {
    this.props.history.push({
      pathname: `myCpdRecord/${id}/${mode}`,
      state: item,
    });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.getCpdCompliantReport(
      this.state.activePage,
      this?.state?.yearCpd,
      column,
      direction
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let loadCpdIndividual;

    if (this.state?.loadCpdIndividual !== null) {
      loadCpdIndividual = this.state?.loadCpdIndividual?.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item?.MemberNumber}</td>
            <td>{item?.username}</td>
            <td>
              {item?.IsCPDCompliant === 'true' ? (
                <img src={yesIcon} alt="yesIcon" />
              ) : (
                <img src={noIcon} alt="noIcon" />
              )}
            </td>
            <td>{item?.CPDYear}</td>
            <td>{item?.CPDTypeName}</td>
            <td>{item?.CourseName}</td>
            <td>{item?.Venue}</td>
            <td>{item?.Trainer}</td>
            <td>
              {item?.CompletionDate
                ? moment(item?.CompletionDate).format('ll')
                : 'na'}
            </td>
            <td>{item?.Hours}</td>
            <td>{item?.Minutes}</td>
            <td>
              {item?.FileName ? (
                <button
                  onClick={() => this.handleDownloadFile(item?.CPDWorkflowId)}
                  className="icon-individual"
                  data-toggle="tooltip"
                  title={item?.AttachmentName}
                >
                  <i className="fa fa-paperclip"> </i>
                </button>
              ) : null}
            </td>
            <td>
              {item?.IsLocked === false ? (
                <>
                  <button
                    className="icon-individual"
                    data-toggle="tooltip"
                    title="Edit Cpd"
                    onClick={() =>
                      this.editViewHandler(item?.CPDWorkflowId, 'edit', item)
                    }
                  >
                    <i className="fa fa-edit"> </i>
                  </button>
                  <button
                    className="icon-individual"
                    data-toggle="tooltip"
                    title="Lock Cpd"
                    onClick={() => this.cpdLockedHandler(item?.CPDWorkflowId)}
                  >
                    <i className="fa fa-unlock"> </i>
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="icon-individual"
                    data-toggle="tooltip"
                    title="View Cpd"
                    onClick={() =>
                      this.editViewHandler(item?.CPDWorkflowId, 'view', item)
                    }
                  >
                    <i className="fa fa fa-eye"> </i>
                  </button>
                  <button
                    className="icon-individual"
                    data-toggle="tooltip"
                    onClick={() => this.cpdUnLockedHandler(item?.CPDWorkflowId)}
                    title="Unlock Cpd"
                  >
                    <i className="fa fa-lock"> </i>
                  </button>
                </>
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>User Name</label>
                        <input
                          type="user name"
                          value={this.state.cpdUsername}
                          className="form-control"
                          id="user name"
                          onChange={(e) =>
                            this.setState({ cpdUsername: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Course Name</label>
                        <input
                          type="CourseName"
                          className="form-control"
                          value={this.state.cpdCourseName}
                          onChange={(e) =>
                            this.setState({ cpdCourseName: e.target.value })
                          }
                          id="CourseName"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Memebership number</label>

                        <input
                          type="memebership number"
                          className="form-control"
                          id="memebership number"
                          value={this.state.cpdMemberNum}
                          onChange={(e) =>
                            this.setState({ cpdMemberNum: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Year</label>
                        <select
                          value={this.state.cpdYear}
                          className="form-control"
                          onChange={(e) =>
                            this.setState({
                              cpdYear: e.target.value,
                            })
                          }
                          id="sel1"
                        >
                          <option></option>
                          <option value={'2022'}>2022</option>
                          <option value={'2023'}>2023</option>
                          <option value={'2024'}>2024</option>
                          <option value={'2025'}>2025</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Host</label>
                        <select
                          className="form-control"
                          onChange={(e) =>
                            this.setState({ cpdHostName: e.target.value })
                          }
                          value={this.state.cpdHostName}
                        >
                          <option value="" disabled hidden></option>
                          {this?.state?.loadHost?.length &&
                            this?.state?.loadHost?.map((item, index) => {
                              return (
                                <option key={index} value={item?.ID}>
                                  {item?.Name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchData}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="gridTopButtons">
              <button
                type="button"
                onClick={() => window.print()}
                className="btn btn-danger btn-circle btn-lg "
              >
                <i className="fa fa-print"> </i>
              </button>

              <Dropdown id="dropdown-custom-1">
                <Dropdown.Toggle
                  className="btn btn-success btn-circle btn-lg"
                  style={{ marginLeft: '10px' }}
                  noCaret
                >
                  <i className="fa fa-file-pdf-o"> </i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel('All');
                    }}
                    eventKey="4"
                  >
                    All
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2022);
                    }}
                    eventKey="3"
                  >
                    2022
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2023);
                    }}
                    eventKey="4"
                  >
                    2023
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2024);
                    }}
                    eventKey="5"
                  >
                    2024
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2025);
                    }}
                    eventKey="6"
                  >
                    2025
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="col-md-6">
            <div className="gridTopDropdown">
              Show{' '}
              <select
                className="input-sm"
                aria-invalid="false"
                onChange={(e) => this.pageChange(e.target.value)}
              >
                <option label="10" value="10">
                  10
                </option>
                <option label="20" value="20">
                  20
                </option>
                <option label="30" value="30">
                  30
                </option>
              </select>{' '}
              entries
            </div>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th onClick={this.onSort('MemberNumber')}>
                  Member Number{' '}
                  <i className={this.setArrow('MemberNumber')}> </i>
                </th>
                <th onClick={this.onSort('UserName')}>
                  User Name <i className={this.setArrow('UserName')}> </i>
                </th>
                <th>CPD Compliant </th>
                <th onClick={this.onSort('CPDYear')}>
                  Year <i className={this.setArrow('CPDYear')}> </i>
                </th>
                <th onClick={this.onSort('CPDTypeName')}>
                  CPDType <i className={this.setArrow('CPDTypeName')}> </i>
                </th>
                <th onClick={this.onSort('CourseName')}>
                  Course <i className={this.setArrow('CourseName')}> </i>
                </th>
                <th onClick={this.onSort('Venue')}>
                  Venue <i className={this.setArrow('Venue')}> </i>
                </th>
                <th onClick={this.onSort('Trainer')}>
                  Trainer <i className={this.setArrow('Trainer')}> </i>
                </th>
                <th onClick={this.onSort('CompletionDate')}>
                  Completion Date{' '}
                  <i className={this.setArrow('CompletionDate')}> </i>
                </th>
                <th onClick={this.onSort('Hours')}>
                  Hours<i className={this.setArrow('Hours')}> </i>
                </th>
                <th onClick={this.onSort('Minutes')}>
                  Minutes<i className={this.setArrow('Minutes')}> </i>
                </th>
                <th>Attachment</th>
                <th>View/Edit</th>
              </tr>
            </thead>
            <tbody>{loadCpdIndividual}</tbody>
          </table>
          {loadCpdIndividual?.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CompliantReport);
